import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  style: {"padding":"0px 20px"},
  "element-loading-text": "正在提交数据，请稍后"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "fc-d" }, "工号之间请使用【英文半角分号】【;】分隔", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, onMounted, reactive, unref } from 'vue';
import { ElForm, FormRules, ElMessage } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { useDictionary } from '@/store/dictionary.store';
import { ErpUserAsyncApi } from '@/apis/basics/users/apis';
import { RoleDowndownListApi } from '@/apis/basics/roles/api';

// emits

export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {


const { getSelectList } = useDictionary();

const formRef = ref<ComponentRef<typeof ElForm>>();

const formSchema = ref<any>({});

/* 表单验证规则 */
const roleList = ref<any[]>([]);

const formRules: FormRules = {
	role_id: [{ required: true, message: '请选择用户角色', trigger: 'change' }],
	accounts: [{ required: true, message: '请输入需同步的工号列表', trigger: 'blur' }],
};

const state = reactive({
	show: false,
	loading: false,
	isEditor: false,
});

const load = {
	/* 角色选择列表 */
	getRoleList: async () => {
		const { succeeded, data } = await RoleDowndownListApi();
		roleList.value = !succeeded ? [] : data || [];
	},
};

/* 保存数据 */
const onSaveBtnClick = () => {
	unref(formRef)?.validate(async (isValid: boolean) => {
		if (!isValid) return;

		state.loading = true;
		const data = unref(formSchema);

		const { succeeded, errors } = await ErpUserAsyncApi(data);
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			ElMessage.success('同步成功');
			state.show = false;
		}

		state.loading = false;
		$emits('refresh');
	});
};

const exposeFunc = {
	openDialog: () => {
		formSchema.value = {};
		state.show = true;
	},
};

expose({ ...exposeFunc });

onMounted(() => {
	load.getRoleList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).show) = $event)),
    title: "同步用户数据(ERP)",
    style: {"width":"520px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        class: "w90",
        type: "primary",
        disabled: _unref(state).loading,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        class: "w90",
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          size: "small",
          ref_key: "formRef",
          ref: formRef,
          "label-width": "80px",
          model: formSchema.value,
          "label-position": 'right',
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "初始角色",
                      prop: "role_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.role_id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.role_id) = $event)),
                          class: "w100p",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (role) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: role.name,
                                value: role.value
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "工号列表",
                      prop: "accounts"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "500",
                          modelValue: formSchema.value.accounts,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.accounts) = $event)),
                          rows: "4",
                          placeholder: "请输入需要同步的人员工号，使用“;”分隔"
                        }, null, 8, ["modelValue"]),
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})